import BankLogo from './bank-logo';

export default BankLogo;
